import { helpers } from 'vuelidate/lib/validators'

const fonctionTest = function(value,param) {
  if(!value) {
    return true;
  }
  if (!value.size) {
    return true;
  }
  if (value.size >= (param * 1000000)) {
    return false;
  }
  return true;
}

const maxsizefile = (param) =>
  helpers.withParams(
    { type: 'maxsizefile', value: param },
    (value) => fonctionTest(value,param)
  )

export { maxsizefile };
